// WHITE LINE - Extended Russian Labels Map

export const ruLabels = {
  // === SHIPMENT STATUSES ===
  shipmentStatus: {
    DRAFT: 'Черновик',
    BOOKING_REQUESTED: 'Заявка на бронирование',
    BOOKING_CONFIRMED: 'Бронирование подтверждено',
    CONFIRMED: 'Подтверждена',
    CARGO_RECEIVED_CN: 'Груз принят в Китае',
    LOADED_CN: 'Загружен в Китае',
    IN_TRANSIT: 'В пути',
    ARRIVED_BORDER: 'Прибыл на границу',
    CUSTOMS_CLEARANCE: 'Таможенное оформление',
    IN_TRANSIT_RU: 'В пути по России',
    ARRIVED_MOSCOW: 'Прибыл в Москву',
    ON_TEMP_STORAGE: 'На временном хранении',
    ON_TS: 'На ТС (готов к выпуску)',
    CUSTOMS_RELEASED: 'Выпущен с таможни',
    DELIVERED: 'Доставлен',
    COMPLETED: 'Завершён',
    CANCELLED: 'Отменён',
  },

  // === STATUS TRACKS ===
  trackNames: {
    logistics: 'Логистика',
    docs: 'Документы',
    customs: 'Таможня',
    finance: 'Финансы',
  },

  trackStatuses: {
    // Logistics Track
    PENDING_BOOKING: 'Ожидает бронирования',
    BOOKED: 'Забронировано',
    AWAITING_CARGO: 'Ожидание груза',
    CARGO_RECEIVED: 'Груз принят',
    LOADING: 'Загрузка',
    LOADED: 'Загружен',
    DEPARTED: 'Отправлен',
    IN_TRANSIT: 'В пути',
    ARRIVED: 'Прибыл',
    ARRIVED_TS: 'На ТС',
    ON_TS: 'На ТС',
    UNLOADING: 'Разгрузка',
    UNLOADED: 'Разгружен',
    DELIVERED: 'Доставлен',
    PENDING: 'Ожидание',

    // Docs Track
    DOCS_PENDING: 'Документы ожидаются',
    DOCS_SUBMITTED: 'Документы поданы',
    DOCS_UNDER_REVIEW: 'На проверке',
    DOCS_APPROVED: 'Документы одобрены',
    DOCS_REJECTED: 'Документы отклонены',
    DOCS_CORRECTION_NEEDED: 'Требуется корректировка',
    DOCS_READY: 'Документы готовы',
    DOCS_ISSUE: 'Проблема с документами',
    // P7 additional docs statuses (only new ones, NOT_STARTED is in customs section)
    CHECKING: 'Проверка',
    LAB_ORDERED: 'Лаборатория заказана',
    DOCS_PARTIAL: 'Документы частично',

    // Customs Track
    NOT_STARTED: 'Не начато',
    AWAITING_DECLARATION: 'Ожидает декларирования',
    DECLARATION_SUBMITTED: 'Декларация подана',
    INSPECTION_SCHEDULED: 'Назначен досмотр',
    INSPECTION_PASSED: 'Досмотр пройден',
    DUTIES_CALCULATED: 'Пошлины рассчитаны',
    DUTIES_PAID: 'Пошлины оплачены',
    RELEASED: 'Выпущен',
    KTS_OPENED: 'КТС открыт',
    KTS_RESOLVED: 'КТС закрыт',
    ON_HOLD_KTS: 'Удержание КТС',

    // IM-70/IM-40 statuses
    IM70_IN_PROGRESS: 'ИМ-70 в процессе',
    IM70_DONE: 'ИМ-70 завершена',
    IM40_SUBMITTED: 'ИМ-40 подана',
    IM40_REGISTERED: 'ДТ ИМ-40 зарегистрирована',
    IM40_FEES_SECURED: 'Пошлины обеспечены',
    IM40_RELEASED: 'Выпуск получен',

    // Finance Track
    AWAITING_PREPAYMENT: 'Ожидает предоплаты',
    PREPAYMENT_RECEIVED: 'Предоплата получена',
    AWAITING_BALANCE: 'Ожидает доплаты',
    BALANCE_RECEIVED: 'Доплата получена',
    FULLY_PAID: 'Полностью оплачено',
    REFUND_PENDING: 'Возврат в обработке',
    REFUNDED: 'Возвращено',
    TOPUP_REQUIRED: 'Требуется пополнение',

    // Marking
    MARKING_PENDING: 'Маркировка ожидается',
    MARKING_IN_PROGRESS: 'Маркировка в процессе',
    MARKING_DONE: 'Маркировка завершена',
  },

  // === GATES (Required Actions) ===
  gates: {
    ACCEPT_OFFER: 'Принять оферту',
    SUBMIT_MCHD: 'Подать МЧД',
    CONFIRM_BOOKING: 'Подтвердить бронирование',
    PAY_PREPAYMENT: 'Оплатить предоплату',
    PAY_AGENT_FEE: 'Оплатить агентское вознаграждение',
    UPLOAD_DOCS: 'Загрузить документы',
    CONFIRM_FREEZE: 'Подтвердить фиксацию',
    PAY_BALANCE: 'Оплатить остаток',
    PAY_CUSTOMS_DUTIES: 'Обеспечить ИМ-70',
    SIGN_RELEASE: 'Подписать выпуск',
    CONFIRM_DELIVERY: 'Подтвердить доставку',
    TOPUP_WAIT: 'Пополнить кошелёк',
    NEED_UNK: 'Загрузить УНК и контракт',
    MARKING_REQUIRED: 'Требуется маркировка',
    DOCS_REQUIRED: 'Требуются документы',
    ON_HOLD_KTS: 'Удержание по КТС',
    RISK_GATE_STOPPED: 'Проверка менеджером (Риск КТС)',
    OPS_REVIEW_WAIT: 'Ожидание проверки брокером',
    DEPARTURE_HOLD: 'Отправка приостановлена',
    ACCEPT_BUDGET: 'Акцептовать заявку',
    CONFIRM_QC: 'Подтвердить качество',
  },

  gateDescriptions: {
    TOPUP_WAIT: 'Недостаточно средств для оплаты. Пополните кошелёк.',
    NEED_UNK: 'Сумма превышает 3 млн ₽. Требуется загрузить УНК и контракт.',
    ON_HOLD_KTS: 'Выпуск заблокирован до разрешения КТС.',
    RISK_GATE_STOPPED: 'Заявленная цена ниже рыночной. Требуется обоснование стоимости.',
    OPS_REVIEW_WAIT: 'Брокер WL подбирает коды ТН ВЭД. Расчёт бюджета на паузе.',
    DEPARTURE_HOLD: 'Отправка приостановлена до устранения замечаний.',
    ACCEPT_BUDGET: 'Ознакомьтесь с бюджетом и акцептуйте заявку для получения QR-пропуска.',
    CONFIRM_QC: 'Проверьте фото/видео товаров и подтвердите качество.',
  },

  // P3 Compliance
  complianceStatus: {
    OK: 'не требуется',
    NEED_UNK: 'требуется',
  },

  complianceDocTypes: {
    'УНК': 'Уведомление о контролируемых сделках',
    'Контракт': 'Контракт с поставщиком',
  },

  // === EVENT TYPES ===
  eventTypes: {
    BOOKING_CREATED: 'Бронирование создано',
    BOOKING_CONFIRMED: 'Бронирование подтверждено',
    SHIPMENT_CREATED: 'Поставка создана',
    SHIPMENT_CONFIRMED: 'Поставка подтверждена',
    CARGO_RECEIVED: 'Груз принят на складе',
    CARGO_LOADED: 'Груз загружен',
    FREEZE_CREATED: 'Freeze Package создан',
    DEPARTED_ORIGIN: 'Отправлен из Китая',
    ARRIVED_DESTINATION: 'Прибыл на склад назначения',
    ARRIVED_TS: 'Прибыл на ТС',
    CUSTOMS_SUBMITTED: 'Подана таможенная декларация',
    CUSTOMS_RELEASED: 'Таможенный выпуск',
    PAYMENT_RECEIVED: 'Платёж получен',
    PAYMENT_INITIATED: 'Платёж инициирован',
    PAYMENT_LINK_CREATED: 'Ссылка на оплату создана',
    DOCS_UPLOADED: 'Документы загружены',
    DOCS_APPROVED: 'Документы одобрены',
    DOCS_ISSUE: 'Проблема с документами',
    FREEZE_CONFIRMED: 'Фиксация подтверждена',
    RELEASE_INITIATED: 'Выпуск инициирован',
    RELEASE_PORTION_ADDED: 'Порция выпуска добавлена',
    RELEASE_SUBMITTED: 'Выпуск подан',
    RELEASE_COMPLETED: 'Выпуск завершён',
    DELIVERY_ORDERED: 'Доставка заказана',
    DELIVERY_CONFIRMED: 'Доставка подтверждена',
    STATUS_CHANGED: 'Статус изменён',
    GATE_OPENED: 'Требуется действие',
    GATE_CLOSED: 'Действие выполнено',
    KTS_OPENED: 'Открыт КТС',
    KTS_RESOLVED: 'КТС разрешён',
    KTS_PAID: 'КТС оплачен',
    // P11 KTS extended events
    KTS_PAYMENT_CREATED: 'Создан платёж по КТС',
    KTS_DISPUTED: 'КТС оспорен',
    KTS_DOCS_UPLOADED: 'Документы по КТС загружены',
    KTS_FUNDS_INSUFFICIENT: 'Недостаточно средств для КТС',
    KTS_STATUS_CHANGED: 'Статус КТС изменён',
    INCIDENT_CREATED: 'Создан инцидент приёмки',
    INCIDENT_RESOLVED: 'Инцидент разрешён',
    TOPUP_WAIT_SET: 'Требуется пополнение кошелька',
    TOPUP_WAIT_CLEARED: 'Требование пополнения снято',
    MARKING_REQUIRED: 'Требуется маркировка',
    MARKING_DONE: 'Маркировка завершена',
    // P1 Legal activation
    START_OFFER_SIGNING: 'Начато подписание оферты',
    OFFER_SIGNED: 'Оферта подписана',
    OFFER_SIGN_CANCELLED: 'Подписание оферты отменено',
    START_MCHD_SIGNING: 'Начато подписание МЧД',
    MCHD_SIGNED: 'МЧД подписана',
    MCHD_SIGN_CANCELLED: 'Подписание МЧД отменено',
    MCHD_SUBMITTED: 'МЧД отправлена экспедитору',
    MCHD_APPROVED: 'МЧД подтверждена',
    MCHD_ACTIVE: 'МЧД активна',
    ORG_ACTIVATED: 'Организация активирована',
    // P3 Compliance
    COMPLIANCE_NEED_UNK: 'Контракт / УНК: требуется',
    COMPLIANCE_DOC_UPLOADED: 'Контракт / УНК: документ загружен',
    COMPLIANCE_PASSED: 'Контракт / УНК загружены',
    SUPPORT_TICKET_CREATED: 'Обращение в поддержку создано',
    // P9 Customs IM-70 events
    CUSTOMS_FEES_REQUESTED_IM70: 'Запрошено обеспечение ИМ-70',
    CUSTOMS_FEES_SECURED_IM70: 'Обеспечение ИМ-70 внесено',
    CUSTOMS_FEES_REJECTED_IM70: 'Обеспечение ИМ-70 отклонено',
    IM70_DECLARATION_REGISTERED: 'ДТ ИМ-70 зарегистрирована',
    IM70_DECLARATION_REJECTED: 'ДТ ИМ-70 отклонена',
    IM70_DONE: 'ИМ-70 завершён',
  },

  // === ORGANIZATION STATUSES ===
  orgStatus: {
    PENDING_ACTIVATION: 'Ожидает активации',
    ACTIVE: 'Активна',
    SUSPENDED: 'Приостановлена',
    BLOCKED: 'Заблокирована',
  },

  mchdStatus: {
    NOT_SUBMITTED: 'Не подана',
    PENDING: 'На рассмотрении',
    APPROVED: 'Одобрена',
    REJECTED: 'Отклонена',
    EXPIRED: 'Истекла',
    // P1 statuses
    MCHD_DRAFT: 'Черновик',
    MCHD_SIGNED: 'Подписана (УКЭП)',
    MCHD_SUBMITTED: 'Отправлена экспедитору',
    MCHD_ACTIVE: 'Активна',
    MCHD_REJECTED: 'Отклонена',
  },

  offerStatus: {
    NOT_SIGNED: 'Не подписана',
    PENDING: 'На подписании',
    SIGNED: 'Подписана',
  },

  // === WALLET TYPES ===
  walletTypes: {
    LOGISTICS: 'Логистика',
    AGENT: 'Агентский',
  },

  walletCurrency: {
    RUB: '₽',
    CNY: '¥',
  },

  // === PAYMENT STATUSES ===
  paymentStatus: {
    DRAFT: 'Черновик',
    PENDING_SIGN: 'Ожидает подписи',
    SIGNED: 'Подписан',
    SENT_TO_BANK: 'Отправлен в банк',
    PROCESSING: 'В обработке',
    COMPLETED: 'Исполнен',
    FAILED: 'Ошибка',
    CANCELLED: 'Отменён',
    LINK_ISSUED: 'Ссылка создана',
    AWAITING_PAYMENT: 'Ожидает оплаты',
  },

  paymentIntentType: {
    TOPUP: 'Пополнение',
    AGENT_PAYMENT: 'Оплата поставщику',
    CUSTOMS_DUTY: 'Таможенные пошлины',
    SERVICE_FEE: 'Сервисный сбор',
    KTS_DELTA: 'Доначисление КТС',
  },

  // === KTS Statuses (P11 extended) ===
  ktsStatus: {
    // Active statuses
    OPEN: 'Открыт',
    REQ_RECEIVED: 'Открыт',
    PAYMENT_REQUIRED: 'Ожидает оплаты',
    TOPUP_WAIT: 'Требуется пополнение',
    FUNDS_SECURED: 'Средства зарезервированы',
    // Dispute
    DISPUTE_SUBMITTED: 'Оспаривается',
    PENDING_DOCS: 'Ожидает документов',
    UNDER_REVIEW: 'На рассмотрении',
    // Closed
    CLOSED_PAID: 'Закрыт (оплачен)',
    CLOSED_ACCEPTED: 'Закрыт (спор принят)',
    CLOSED_REJECTED: 'Закрыт (спор отклонён)',
    CLOSED_DISPUTED: 'Закрыт (оспорен)',
    CANCELED: 'Отменён',
  },

  ktsDecision: {
    PAY: 'Оплатить',
    DISPUTE: 'Оспорить',
  },

  // === INCIDENT ===
  incidentType: {
    DAMAGE: 'Повреждение',
    SHORTAGE: 'Недостача',
    WRONG_ITEM: 'Пересорт',
    QUALITY_ISSUE: 'Проблема качества',
    DOCS_MISSING: 'Отсутствуют документы',
    OTHER: 'Прочее',
  },

  incidentStatus: {
    OPEN: 'Открыт',
    PENDING_DECISION: 'Ожидает решения',
    ACCEPTED: 'Принят',
    DISPUTED: 'Оспорен',
    RESOLVED: 'Разрешён',
  },

  incidentResolution: {
    ACCEPT_FACT: 'Принять факт',
    RETURN_TO_SUPPLIER: 'Вернуть поставщику',
    DISPOSE: 'Утилизировать',
  },

  // === P4 ACCEPTANCE REPORT ===
  acceptanceReportStatus: {
    NOT_STARTED: 'Не начато',
    IN_PROGRESS: 'В процессе',
    DONE_OK: 'Приёмка завершена',
    DONE_WITH_ISSUES: 'Есть расхождения',
  },

  // === RELEASE ===
  releaseType: {
    PARTIAL: 'Частичный',
    FULL: 'Полный',
  },

  releaseStatus: {
    DRAFT: 'Черновик',
    PENDING: 'Ожидает',
    SUBMITTED: 'Подан',
    APPROVED: 'Одобрен',
    RELEASED: 'Выпущен',
    REJECTED: 'Отклонён',
  },

  // === DELIVERY ===
  deliveryStatus: {
    DRAFT: 'Черновик',
    PENDING: 'Ожидает',
    CONFIRMED: 'Подтверждён',
    IN_TRANSIT: 'В пути',
    DELIVERED: 'Доставлен',
    CANCELLED: 'Отменён',
  },

  // === WAREHOUSES ===
  warehouses: {
    GUANGZHOU: 'Гуанчжоу',
    YIWU: 'Иу',
    SHENZHEN: 'Шэньчжэнь',
    NINGBO: 'Нинбо',
  },

  // === NAVIGATION ===
  navigation: {
    home: 'Главная',
    shipments: 'Поставки',
    finance: 'Финансы',
    profile: 'Профиль',
  },

  // === COMMON UI ===
  common: {
    loading: 'Загрузка...',
    noData: 'Нет данных',
    error: 'Ошибка',
    success: 'Успешно',
    cancel: 'Отменить',
    confirm: 'Подтвердить',
    save: 'Сохранить',
    edit: 'Редактировать',
    delete: 'Удалить',
    back: 'Назад',
    next: 'Далее',
    close: 'Закрыть',
    search: 'Поиск',
    filter: 'Фильтр',
    all: 'Все',
    active: 'Активные',
    completed: 'Завершённые',
    details: 'Подробнее',
    events: 'События',
    documents: 'Документы',
    actions: 'Действия',
    create: 'Создать',
    add: 'Добавить',
    submit: 'Отправить',
    upload: 'Загрузить',
    download: 'Скачать',
    view: 'Просмотреть',
    overview: 'Обзор',
    items: 'Товары',
    invoice: 'Инвойс',
  },

  // === EMPTY STATES ===
  empty: {
    shipments: 'У вас пока нет поставок',
    shipmentsDesc: 'Передайте файлы от поставщика — мы создадим заявку за вас.',
    events: 'Нет событий',
    eventsDesc: 'История событий появится здесь',
    payments: 'Нет платежей',
    paymentsDesc: 'Здесь будет история пополнений и списаний.',
    actions: 'Отлично!',
    actionsDesc: 'В данный момент действий с вашей стороны не требуется. Мы пришлём уведомление, когда понадобится ваше участие.',
    documents: 'Документы формируются автоматически',
    documentsDesc: 'Платформа сгенерировала инвойс и подобрала сертификаты автоматически.',
  },

  // === SHIPMENT CARD ===
  shipmentCard: {
    bookingRef: 'Бронирование',
    route: 'Маршрут',
    nextAction: 'Следующее действие',
    noActionsRequired: 'Действий не требуется',
    viewDetails: 'Подробнее',
    estimatedArrival: 'Ожидаемое прибытие',
    snapshot: 'Версия',
    freeze: 'Freeze',
  },

  // === FINANCE ===
  finance: {
    balance: 'Баланс',
    availableBalance: 'Доступный баланс',
    frozenAmount: 'Заморожено',
    recentTransactions: 'Последние операции',
    topUp: 'Пополнить',
    withdraw: 'Вывести',
    paymentHistory: 'История платежей',
    createPaymentLink: 'Создать ссылку на оплату',
    paySupplier: 'Оплатить поставщику',
    pendingTopup: 'Ожидает пополнения',
    topupRequired: 'Требуется пополнение',
    walletLogistics: 'Кошелёк логистики (RUB)',
    walletAgent: 'Агентский кошелёк (CNY)',
  },

  // === PROFILE ===
  profile: {
    organization: 'Организация',
    activationStatus: 'Статус активации',
    mchdStatus: 'Статус МЧД',
    offerStatus: 'Статус оферты',
    offerAccepted: 'Принята',
    offerPending: 'Не принята',
    users: 'Пользователи',
    settings: 'Настройки',
    logout: 'Выйти',
  },

  // === CREATE SHIPMENT WIZARD ===
  wizard: {
    title: 'Создание поставки',
    step1: 'Склад и маршрут',
    step2: 'Товары',
    step3: 'Контракт / УНК',
    step4: 'Подтверждение',
    selectWarehouse: 'Выберите склад в Китае',
    routeFixed: 'Китай → Москва (Авто)',
    addItem: 'Добавить товар',
    unkRequired: 'Сумма превышает 3 000 000 ₽. Требуется загрузить УНК и контракт.',
    unkNotRequired: 'УНК не требуется',
    uploadUnk: 'Загрузить УНК',
    uploadContract: 'Загрузить контракт',
    confirmCreate: 'Создать поставку',
    shipmentCreated: 'Поставка создана',
    // v2.1 Data Intake
    dataIntakeTitle: 'Загрузите данные о товарах',
    dataIntakeDesc: 'Загрузите файлы от поставщика (инвойс, прайс-лист) и/или вставьте ссылки на товары. Наши ИИ-агенты извлекут данные и подберут коды ТН ВЭД автоматически.',
    dataIntakePriceNote: 'Убедитесь, что в источниках указана цена за единицу.',
    addLink: 'Добавить ссылку',
    linkPlaceholder: 'Ссылка на товар (1688, Taobao...)',
    // v2.1 Export Regime
    exportRegimeTitle: 'Экспортный режим КНР',
    exportRegime1039: '1039',
    exportRegime1039Sub: 'мелкий опт',
    exportRegime9710: '9710',
    exportRegime9710Sub: 'e-com B2B',
    exportRegime0110: '0110',
    exportRegime0110Sub: 'контрактный',
    exportRegimeHint: 'Уточните у поставщика, какую процедуру экспорта он использует. Это влияет на пакет документов и таможенное оформление.',
    usccLabel: 'USCC фабрики (18 символов)',
    usccPlaceholder: 'Введите USCC код фабрики',
    epoaInstruction: 'Инструкция для фабрики: оформить электронную доверенность (e-POA) на таможенного агента White Line',
    copyInstruction: 'Скопировать инструкцию',
    epoaWaiting: 'Ожидаем e-POA от фабрики',
  },

  // === v2.1 SMART GRID & PILLS ===
  smartGrid: {
    currencyLabel: 'Валюта',
    netWeightLabel: 'Нетто (кг)',
    grossWeightLabel: 'Брутто (кг)',
    totalNetWeight: 'Общ вес (net)',
    pillProvidedOnly: 'Из документа',
    pillWebInference: 'Найдено в сети',
    statusInProgress: 'Определяется...',
    statusApplied: 'Код определён',
    statusNeedConfirmation: 'Требуется подтверждение',
    statusNeedUserInput: 'Нужны данные',
    statusOpsReview: 'На проверке брокера',
    requestBrokerHelp: 'Запросить помощь брокера WL',
    brokerHelpAttachmentRequired: 'Приложите фото или ссылку на товар',
    batchApply: 'Применить ко всем похожим',
    batchApplyCount: 'Применить ко всем похожим ({count} шт.)',
    disputeButton: 'Не согласен с описанием или кодами',
    disputePlaceholder: 'Опишите, что именно неверно...',
    disputeSubmit: 'Перепроверка',
    disputeSelectItems: 'Выберите позиции для пересмотра',
  },

  // === v2.1 INTERCEPT MODAL ===
  interceptModal: {
    title: 'Остались товары с неполными данными',
    description: 'Передача брокеру приостановит выдачу QR-кода ориентировочно на 4 часа.',
    itemsCount: '{count} шт. требуют уточнения',
    clarifyMyself: 'Уточнить самому (Быстро)',
    sendToBroker: 'Передать брокеру WL',
  },

  // === v2.1 BUDGET & ACCEPT ===
  budget: {
    title: 'Бюджет заявки',
    preliminary: 'Предварительный',
    revised: 'Уточнённый',
    accepted: 'Акцептован',
    acceptButton: 'Акцептовать заявку',
    pausedTitle: 'Расчёт бюджета на паузе',
    pausedDesc: 'Брокер подбирает коды ТН ВЭД. Вы можете ускорить процесс, добавив данные.',
    pausedCta: 'Добавить данные (Ускорить)',
    scheduleTitle: 'График платежей',
    category: 'Категория',
    amount: 'Сумма',
    dueDate: 'Срок',
    paid: 'Оплачено',
    unpaid: 'Не оплачено',
  },

  // === v2.1 QR PASS ===
  qrPass: {
    title: 'QR-пропуск на склад',
    notAvailable: 'QR-пропуск будет доступен после акцепта бюджета',
    terminalAddresses: 'Адреса терминалов',
  },

  // === v2.1 QC ===
  qc: {
    title: 'Контроль качества',
    confirmQuality: 'Подтвердить качество',
    rejectQuality: 'Отклонить / Сообщить о браке',
    status: {
      PENDING: 'Ожидает проверки',
      CONFIRMED: 'Качество подтверждено',
      REJECTED: 'Отклонено',
    },
  },

  // === v2.1 FSA DOCS ===
  fsaDocs: {
    title: 'Сертификаты (ФСА)',
    found: 'Найдено в базе ФСА',
    needToOrder: 'Требуется оформить',
    delegateToWl: 'Поручить WL оформление',
    uploadOwn: 'Загрузить свои',
  },

  // === v2.1 SPLIT DELIVERY ===
  splitDelivery: {
    title: 'Распределение по складам',
    portionLabel: 'Порция №{number}',
    warehouseLabel: 'Склад',
    qtyLabel: 'Кол-во',
    addWarehouse: '+ Добавить склад',
    availableQty: 'Доступно',
    totalByWarehouse: 'Итого по складам',
    confirmAllocation: 'Подтвердить распределение',
    validationError: 'Распределите все единицы товара',
    warehouses: {
      WB_KOLEDINO: 'WB Коледино',
      WB_ELECTROSTAL: 'WB Электросталь',
      WB_KAZAN: 'WB Казань',
      WB_KRASNODAR: 'WB Краснодар',
      OZON_KHORUGVINO: 'Ozon Хоругвино',
      OZON_TVER: 'Ozon Тверь',
      OZON_KAZAN: 'Ozon Казань',
    },
  },

  // === v2.1 EXPEDITION RECEIPT ===
  expeditionReceipt: {
    download: 'Скачать экспедиторскую расписку',
  },

  // === v2.1 ACTION CENTER (PULSE) ===
  pulse: {
    title: 'Пульс',
    inTransit: 'В пути',
    atCustoms: 'На таможне',
    atWarehouse: 'На складе',
    allGood: 'Всё идёт по плану',
    attention: 'Требует внимания',
  },

  // === SHIPMENT HUB TABS ===
  shipmentTabs: {
    overview: 'Обзор',
    items: 'Товары/Инвойс',
    reception: 'Приёмка CN',
    logistics: 'Логистика',
    documents: 'Документы',
    marking: 'Маркировка',
    customs: 'Таможня',
    finance: 'Финансы',
    events: 'События',
  },

  // === RELEASE ===
  release: {
    title: 'Выпуск ИМ-40',
    createRelease: 'Создать выпуск',
    addPortion: 'Добавить порцию',
    submitRelease: 'Подать на выпуск',
    remainingOnTs: 'Остаток на ТС',
    releasedQty: 'Выпущено',
    portions: 'Порции выпуска',
  },

  // === DELIVERY ===
  delivery: {
    title: 'Доставка',
    orderDelivery: 'Заказать доставку',
    deliveryOrders: 'Заказы на доставку',
    address: 'Адрес доставки',
    estimatedDelivery: 'Ориентировочная дата',
  },

  // === KTS (legacy, kept for compatibility) ===
  kts: {
    title: 'Корректировка таможенной стоимости (КТС)',
    delta: 'Доначисление',
    deadline: 'Срок оплаты/оспаривания',
    uploadDocs: 'Загрузить пакет документов',
    pay: 'Оплатить',
    dispute: 'Оспорить',
    releaseBlocked: 'Выпуск заблокирован до разрешения КТС',
  },

  // === KTS P11 (full UI labels) ===
  ktsP11: {
    // Status labels (canonical P11 statuses)
    statuses: {
      OPEN: 'Открыт',
      REQ_RECEIVED: 'Открыт',
      PAYMENT_REQUIRED: 'Ожидает оплаты',
      TOPUP_WAIT: 'Ожидает пополнения',
      FUNDS_SECURED: 'Средства зарезервированы',
      DISPUTE_SUBMITTED: 'Оспаривается',
      PENDING_DOCS: 'Ожидает документов',
      UNDER_REVIEW: 'На рассмотрении',
      CLOSED_PAID: 'Закрыт (оплачено)',
      CLOSED_ACCEPTED: 'Закрыт (спор принят)',
      CLOSED_REJECTED: 'Закрыт (отклонено)',
      CANCELED: 'Отменён',
    } as Record<string, string>,
    banner: {
      title: 'КТС: требуется действие',
      amount: 'Доначисление',
      deadline: 'Дедлайн',
      cta: 'Открыть детали',
    },
    sheet: {
      title: 'КТС: детали',
      caseNumber: 'Номер кейса',
      amount: 'Сумма доначисления',
      status: 'Статус',
      opened: 'Открыт',
      reason: 'Причина',
      deadline: 'Дедлайн',
      createdAt: 'Создан',
      actionsTitle: 'Действия',
      timeline: 'История событий',
      payButton: 'Оплатить доначисление',
      disputeButton: 'Оспорить',
      insufficientFunds: 'Недостаточно средств',
      topupCta: 'Пополнить кошелёк',
      deficit: 'Не хватает',
      balance: 'Доступно в кошельке',
      bankLink: 'Открыть ссылку банка (мок)',
      simulatePaid: 'Симулировать: оплачено',
    },
    payment: {
      balance: 'Баланс кошелька',
      required: 'Требуется',
      deficit: 'Не хватает',
      alreadyPaid: 'КТС уже оплачен',
      disputed: 'КТС оспаривается',
      bankLinkReady: 'Ссылка для оплаты готова',
      openBank: 'Открыть ссылку банка (мок)',
      simulatePaid: 'Симулировать: оплачено',
    },
    actions: {
      pay: 'Оплатить',
      topup: 'Пополнить кошелёк',
      dispute: 'Оспорить',
    },
    dispute: {
      title: 'Оспаривание КТС',
      instructions: 'Опишите причину оспаривания и приложите подтверждающие документы. Срок рассмотрения: до 14 рабочих дней.',
      commentLabel: 'Комментарий',
      commentPlaceholder: 'Опишите причину оспаривания...',
      uploadDocs: 'Загрузить документы',
      attachDocs: 'Загрузить документы',
      submit: 'Отправить обращение',
      support: 'Написать в поддержку',
      supportCta: 'Написать в поддержку',
      submitted: 'Обращение отправлено',
      yourMessage: 'Ваше обращение',
    },
    timeline: {
      title: 'История событий',
      empty: 'Нет событий по КТС',
    },
    events: {
      opened: 'КТС открыт',
      paymentCreated: 'Создан платёж по КТС',
      paid: 'КТС оплачен',
      disputed: 'КТС оспорен',
      resolved: 'КТС закрыт',
      docsUploaded: 'Документы по КТС загружены',
      fundsInsufficient: 'Недостаточно средств для оплаты КТС',
    },
  },

  // === INCIDENT ===
  incident: {
    title: 'Инцидент приёмки',
    accept: 'Согласовать',
    dispute: 'Оспорить',
    photos: 'Фотографии',
    description: 'Описание',
  },

  // === DEBUG MENU ===
  debug: {
    title: 'Симулятор событий',
    description: 'Имитация событий для тестирования',
    selectShipment: 'Выберите поставку',
    sections: {
      logistics: 'Логистика',
      finance: 'Финансы',
      documents: 'Документы',
      marking: 'Маркировка',
      kts: 'КТС',
      activation: 'Юр.активация',
      compliance: 'Контракт / УНК',
      reception: 'Приёмка CN',
      customs: 'Таможня (ИМ-70)',
      customsIm40: 'ИМ-40 / Выпуск',
      deliveryP10: 'Доставка',
    },
    actions: {
      // P4 Reception actions
      preAlertSent: { title: 'PRE_ALERT_SENT', desc: 'Отправлено предуведомление на склад' },
      arrivedCn: { title: 'ARRIVED_CN', desc: 'Груз прибыл на склад в Китае' },
      acceptanceOk: { title: 'Приёмка OK', desc: 'Приёмка без расхождений' },
      acceptanceIssue: { title: 'Создать инцидент', desc: 'Создать инцидент приёмки (недостача)' },
      loadedCn: { title: 'LOADED_CN', desc: 'Загружен + создаёт FreezePackage + Freeze' },
      logisticsInTransit: { title: 'В пути', desc: 'Груз отправлен из Китая' },
      logisticsArrivedRf: { title: 'Прибыл в РФ', desc: 'Груз прибыл на границу РФ' },
      arrivedTs: { title: 'ARRIVED_TS', desc: 'Прибыл на ТС (временное хранение)' },
      onTs: { title: 'ON_TS', desc: 'На ТС, готов к выпуску' },
      addMoney: { title: '+10 000 ₽', desc: 'Пополнить логистический кошелёк' },
      setTopupWait: { title: 'TOPUP_WAIT', desc: 'Создать требование пополнения' },
      clearTopupWait: { title: 'Снять TOPUP_WAIT', desc: 'Убрать требование пополнения' },
      docsReady: { title: 'DOCS_READY', desc: 'Документы готовы' },
      docsIssue: { title: 'DOCS_ISSUE', desc: 'Проблема с документами' },
      // P7 Documents debug actions
      docsChecking: { title: 'CHECKING', desc: 'Документы на проверке' },
      docsPartial: { title: 'DOCS_PARTIAL', desc: 'Документы частично (есть пропуски)' },
      labOrder: { title: 'LAB_ORDERED', desc: 'Заказать лабораторию' },
      labReady: { title: 'LAB_READY', desc: 'Результаты лаборатории готовы' },
      markingRequired: { title: 'MARKING_REQUIRED', desc: 'Требуется маркировка' },
      markingDone: { title: 'MARKING_DONE', desc: 'Маркировка завершена' },
      openKts: { title: 'Открыть КТС', desc: 'Создать КТС с hold ON_HOLD_KTS' },
      ktsNeedDocs: { title: 'КТС: запрос документов', desc: 'Статус: требуются документы' },
      ktsReadyToPay: { title: 'КТС: готово к оплате', desc: 'Статус: PAYMENT_REQUIRED' },
      ktsDisputed: { title: 'КТС: оспорено', desc: 'Статус: DISPUTE_SUBMITTED' },
      closeKtsAccepted: { title: 'Закрыть КТС (принят)', desc: 'CLOSED_ACCEPTED' },
      closeKtsPaid: { title: 'Закрыть КТС (оплачен)', desc: 'CLOSED_PAID' },
      // P1 Activation actions
      toggleOffer: { title: 'Оферта ВКЛ/ВЫКЛ', desc: 'Переключить is_offer_accepted' },
      setMchdDraft: { title: 'МЧД: Черновик', desc: 'mchd_status = MCHD_DRAFT' },
      setMchdSigned: { title: 'МЧД: Подписана', desc: 'mchd_status = MCHD_SIGNED' },
      setMchdSubmitted: { title: 'МЧД: Отправлена', desc: 'mchd_status = MCHD_SUBMITTED' },
      setMchdActive: { title: 'МЧД: Активна', desc: 'mchd_status = MCHD_ACTIVE' },
      setMchdRejected: { title: 'МЧД: Отклонена', desc: 'mchd_status = MCHD_REJECTED' },
      activateOrg: { title: 'Активировать орг.', desc: 'Полная активация (оферта + МЧД)' },
      deactivateOrg: { title: 'Сбросить активацию', desc: 'Вернуть PENDING_ACTIVATION' },
      // P3 Compliance
      simulateNeedUnk: { title: 'NEED_UNK (>3 млн)', desc: 'Установить сумму > 3 млн ₽ и открыть gate' },
      clearNeedUnk: { title: 'Снять NEED_UNK', desc: 'Установить сумму < 3 млн ₽ и закрыть gate' },
      // P3 Price Guard
      priceGuardHighRisk: { title: 'Риск КТС', desc: 'Установить HIGH_RISK_KTS, ожидает решения' },
      priceGuardApproved: { title: 'Цены одобрены', desc: 'Оператор одобрил цены' },
      // System
      resetAllData: { title: 'Сбросить все данные', desc: 'Очистить localStorage и вернуть mock данные' },
      priceGuardRejected: { title: 'Конфликт по цене (оператор)', desc: 'Установить opsDecision=REJECTED' },
      // P9 Customs IM-70 debug actions
      im70FeesRequested: { title: 'Запрос обеспечения', desc: 'CUSTOMS_FEES_REQUESTED_IM70 + gate' },
      im70FeesSecured: { title: 'Обеспечение внесено', desc: 'Зарезервировать средства' },
      im70DeclarationRegistered: { title: 'ДТ зарегистрирована', desc: 'IM70_DECLARATION_REGISTERED' },
      im70Done: { title: 'ИМ-70 завершён', desc: 'IM70_DONE' },
      im70FeesRejected: { title: 'Обеспечение отклонено', desc: 'CUSTOMS_FEES_REJECTED_IM70' },
      // P10 IM-40 / Release / Delivery debug actions
      im40Submitted: { title: 'ИМ-40: подать', desc: 'customsTrack → IM40_SUBMITTED' },
      im40DeclRegistered: { title: 'ИМ-40: регистрация ДТ', desc: 'Генерирует номер ДТ ИМ-40' },
      im40FeesSecured: { title: 'ИМ-40: обеспечить пошлины', desc: 'reserveFundsForIm40' },
      im40Released: { title: 'ИМ-40: выпуск', desc: 'completeRelease → IM40_RELEASED' },
      releaseAddPortion: { title: 'Выпуск: добавить порцию', desc: 'addReleasePortion' },
      releaseSubmit: { title: 'Выпуск: подать', desc: 'submitRelease' },
      releasePortionDone: { title: 'Выпуск: выпустить порцию', desc: 'releasePortion' },
      releaseComplete: { title: 'Выпуск: завершить', desc: 'completeRelease' },
      deliveryCreated: { title: 'Доставка: создана', desc: 'initDeliveryIfNeeded' },
      deliveryInTransit: { title: 'Доставка: в пути', desc: 'setDeliveryStatus IN_TRANSIT' },
      deliveryDelivered: { title: 'Доставка: доставлено', desc: 'setDeliveryStatus DELIVERED' },
      deliveryConfirmed: { title: 'Доставка: подтвердить', desc: 'confirmDelivery' },
    },
    eventAdded: 'Событие добавлено',
  },

  // ============================================================================
  // CANONICAL — Step 3 v6 Status Models
  // ============================================================================
  // This section contains Step 3 canonical codes with fully localized Russian labels.
  // NOT connected to UI — prepared for engineering phase.
  // @see docs/sync/mapping_table.md for full mapping reference
  // @see docs/sync/naming_rules.md for naming conventions
  // ============================================================================

  canonical: {
    // Shipment Status — canonical shipment lifecycle (3 values only)
    // All other "life" states belong to tracks (Logistics, Customs, Delivery)
    shipmentStatus: {
      DRAFT: 'Черновик',
      CONFIRMED: 'Подтверждена',
      CANCELED: 'Отменена',
    },

    // Logistics Track Status Model (9 values)
    logisticsStatus: {
      CREATED: 'Создана',
      PRE_ALERT_SENT: 'Предуведомление отправлено',
      ARRIVED_CN: 'Прибыл в Китай',
      LOADED_CN: 'Загружен в Китае',
      IN_TRANSIT: 'В пути',
      ARRIVED_RF: 'Прибыл в РФ',
      ARRIVED_TS: 'Прибыл на ТС',
      ON_TS: 'На ТС',
      CANCELED: 'Отменён',
    },

    // Documents Track Status Model (7 values)
    documentsStatus: {
      NOT_STARTED: 'Не начато',
      CHECKING: 'Проверка',
      LAB_ORDERED: 'Лаборатория заказана',
      DOCS_READY: 'Документы готовы',
      DOCS_PARTIAL: 'Документы частично',
      DOCS_ISSUE: 'Проблема с документами',
      CANCELED: 'Отменён',
    },

    // Customs Track Status Model (11 values)
    customsTrackStatus: {
      NOT_STARTED: 'Не начато',
      IM70_IN_PROGRESS: 'ИМ-70 в процессе',
      IM70_DONE: 'ИМ-70 завершён',
      IM40_DRAFT: 'ИМ-40 черновик',
      IM40_SUBMITTED: 'ИМ-40 подан',
      IM40_DECLARATION_REGISTERED: 'ДТ ИМ-40 зарегистрирована',
      IM40_FEES_SECURED: 'Обеспеченность ИМ-40',
      IM40_RELEASED: 'Выпуск ИМ-40',
      ON_HOLD_KTS: 'Удержание КТС',
      FAILED: 'Ошибка',
      CANCELED: 'Отменён',
    },

    // Wallet/Reserve Status Model (4 values)
    walletReserveStatus: {
      FUNDS_AVAILABLE: 'Средства доступны',
      TOPUP_WAIT: 'Ожидание пополнения',
      FUNDS_RESERVED_FOR_IM70: 'Средства зарезервированы для ИМ-70',
      FUNDS_RESERVED_KTS: 'Средства зарезервированы КТС',
    },

    // Payment Intent Status Model (9 values)
    paymentIntentStatus: {
      DRAFT: 'Черновик',
      BANK_DRAFT_CREATED: 'Черновик создан в банке',
      LINK_ISSUED: 'Ссылка выдана',
      AWAITING_BANK_SIGNATURE: 'Ожидание подписи банка',
      SUBMITTED_TO_BANK: 'Отправлено в банк',
      IN_PROGRESS: 'В процессе',
      COMPLETED: 'Завершён',
      FAILED: 'Ошибка',
      CANCELED: 'Отменён',
    },

    // Marking Applicability — per-SKU outcome (3 values)
    markingApplicability: {
      REQUIRED: 'Требуется',
      NOT_REQUIRED: 'Не требуется',
      UNKNOWN: 'Не определено',
    },

    // Marking Status Model (5 values)
    markingStatus: {
      NOT_REQUIRED: 'Не требуется',
      MARKING_REQUIRED: 'Требуется маркировка',
      MARKING_IN_PROGRESS: 'Маркировка в процессе',
      MARKING_DONE: 'Маркировка завершена',
      MARKING_FAILED: 'Ошибка маркировки',
    },

    // Delivery Status Model (5 values)
    deliveryStatus: {
      PLANNED: 'Запланировано',
      IN_TRANSIT: 'В пути',
      DELIVERED: 'Доставлен',
      RETURNED: 'Возврат',
      CANCELED: 'Отменён',
    },

    // Release Operation Status (5 values)
    releaseOperationStatus: {
      PENDING: 'Ожидание',
      PICKING: 'Сборка',
      PICKED: 'Собрано',
      SHIPPED: 'Отгружено',
      CANCELED: 'Отменён',
    },

    // Release Portion Status (4 values)
    releasePortionStatus: {
      CREATED: 'Создана',
      ASSIGNED: 'Назначена',
      RELEASED: 'Выпущена',
      CANCELED: 'Отменена',
    },

    // Risk Flag (4 values)
    riskFlag: {
      GREEN: 'Зелёный',
      YELLOW: 'Жёлтый',
      RED: 'Красный',
      HIGH_RISK_KTS: 'Высокий риск КТС',
    },

    // Gate Type — canonical gates only (4 values)
    // NO "Комплаенс" — forbidden term in UI
    gateType: {
      TOPUP_WAIT: 'Пополнить кошелёк',
      NEED_UNK: 'Загрузить УНК и контракт',
      MARKING_REQUIRED: 'Требуется маркировка',
      ON_HOLD_KTS: 'Удержание по КТС',
      RISK_GATE_STOPPED: 'Проверка менеджером (Риск КТС)',
      OPS_REVIEW_WAIT: 'Ожидание проверки брокером',
      DEPARTURE_HOLD: 'Отправка приостановлена',
      ACCEPT_BUDGET: 'Акцептовать заявку',
      CONFIRM_QC: 'Подтвердить качество',
    },

    // Event Type — canonical events from Step 3 Event Catalog (28 values)
    eventType: {
      SHIPMENT_CREATED: 'Поставка создана',
      SHIPMENT_UPDATED: 'Поставка обновлена',
      SHIPMENT_CONFIRMED: 'Поставка подтверждена',
      SHIPMENT_CANCELED: 'Поставка отменена',
      PROVIDER_LOGISTICS_STATUS: 'Статус логистики от провайдера',
      PROVIDER_CUSTOMS_STATUS: 'Статус таможни от провайдера',
      GATE_OPENED: 'Шлюз открыт',
      GATE_CLOSED: 'Шлюз закрыт',
      DOCUMENT_UPLOADED: 'Документ загружен',
      DOCUMENT_VERIFIED: 'Документ проверен',
      DOCUMENT_REJECTED: 'Документ отклонён',
      PAYMENT_CREATED: 'Платёж создан',
      PAYMENT_COMPLETED: 'Платёж завершён',
      PAYMENT_FAILED: 'Платёж не прошёл',
      WALLET_TOPUP: 'Пополнение кошелька',
      RESERVE_CREATED: 'Резерв создан',
      RESERVE_RELEASED: 'Резерв снят',
      KTS_CASE_OPENED: 'Дело КТС открыто',
      KTS_CASE_RESOLVED: 'Дело КТС разрешено',
      INCIDENT_CREATED: 'Инцидент создан',
      INCIDENT_RESOLVED: 'Инцидент разрешён',
      RELEASE_CREATED: 'Выпуск создан',
      RELEASE_COMPLETED: 'Выпуск завершён',
      DELIVERY_STARTED: 'Доставка начата',
      DELIVERY_COMPLETED: 'Доставка завершена',
      MARKING_STARTED: 'Маркировка начата',
      MARKING_COMPLETED: 'Маркировка завершена',
      OPERATOR_NOTE: 'Заметка оператора',
      SYSTEM_AUTO: 'Системное событие',
      // P3 canonical events
      COMPLIANCE_STATUS_SET: 'Статус контракта/УНК обновлён',
      RISK_FLAG_SET: 'Обновлён риск по цене',
      CUSTOMS_PROFILE_FINAL_READY: 'Профиль для таможни готов',
      MARKING_APPLICABILITY_DETERMINED: 'Определена применимость маркировки',
      // P8 Marking events
      MARKING_TASK_CREATED: 'Маркировка: задача создана',
      MARKING_CODES_REQUESTED: 'Маркировка: коды запрошены',
      MARKING_CODES_RECEIVED: 'Маркировка: коды получены',
      MARKING_APPLIED: 'Маркировка: нанесена',
      MARKING_REPORT_PUBLISHED: 'Маркировка: отчёт получен',
      MARKING_FAILED: 'Маркировка: ошибка',
    },
  },

  // === CUSTOMS (P9 + P10) ===
  customs: {
    title: 'Таможня',
    // IM-70 section
    im70Title: 'ИМ-70 (предварительная декларация)',
    readinessTitle: 'Готовность к ИМ-70',
    statusTitle: 'Статус ИМ-70',
    securityTitle: 'Обеспечение ИМ-70',
    declarationTitle: 'Декларация ИМ-70',
    checks: {
      onTs: 'Груз на ТС',
      docsReady: 'Инвойс и упаковочный лист',
      fundsReserved: 'Резерв под ИМ-70',
    },
    steps: {
      feesRequested: 'Запрошено обеспечение',
      feesSecured: 'Обеспечение внесено',
      declarationRegistered: 'ДТ ИМ-70 зарегистрирована',
      done: 'ИМ-70 завершён',
    },
    cta: {
      goToDocs: 'Перейти в Документы',
      goToLogistics: 'Перейти в Перевозку',
      goToFinance: 'Перейти в Финансы',
      goToDelivery: 'Перейти к доставке',
      reserve: 'Зарезервировать под ИМ-70',
      reserveIm40: 'Оплатить пошлины / зарезервировать',
      topup: 'Пополнить кошелёк',
    },
    notEnough: 'Не хватает',
    available: 'Доступно в кошельке',
    securityAmount: 'Сумма обеспечения',
    reserved: 'Резерв создан',
    declarationNumber: 'Номер',
    declarationDate: 'Дата регистрации',
    declarationStatus: 'Статус',
    registered: 'Зарегистрирована',
    rejected: 'Отклонена',
    nextIm40: 'Следующий этап: ИМ-40 (выпуск)',
    notStarted: 'Ожидает начала',
    inProgress: 'В процессе',
    done: 'Завершён',
    awaitingReadiness: 'Ожидаем готовность',
    // IM-40 section
    im40Title: 'ИМ-40 (выпуск)',
    im40ReadinessTitle: 'Готовность к ИМ-40',
    im40StatusTitle: 'Статус ИМ-40',
    im40SecurityTitle: 'Пошлины / обеспечение ИМ-40',
    im40DeclarationTitle: 'Декларация ИМ-40',
    im40Checks: {
      im70Done: 'ИМ-70 завершён',
      docsReady: 'Документы готовы',
      markingDone: 'Маркировка завершена',
      fundsSecured: 'Пошлины/обеспечение ИМ-40',
    },
    im40Steps: {
      submitted: 'ИМ-40 подана',
      registered: 'ДТ ИМ-40 зарегистрирована',
      feesSecured: 'Пошлины обеспечены',
      released: 'Выпуск ИМ-40',
    },
    im40Released: 'Выпуск получен',
    im40AwaitingIm70: 'Ожидает завершения ИМ-70',
    im40NotReady: 'Не все условия выполнены',
    dutiesAmount: 'Сумма пошлин',
    // Release section
    releaseTitle: 'Выпуск товаров',
    releasePending: 'Ожидает выпуска',
    releaseInProgress: 'Выпуск в процессе',
    releaseCompleted: 'Выпуск завершён',
    portions: 'Порции выпуска',
    portionNumber: 'Порция',
    portionBlocked: 'Заблокировано',
    portionBlockedDocs: 'Документы не готовы',
    portionBlockedKts: 'Удержание по КТС',
  },

  // === MARKING (P8) ===
  marking: {
    title: 'Маркировка (Честный ЗНАК)',
    stages: {
      NOT_STARTED: 'Не начато',
      TASK_CREATED: 'Задача создана',
      CODES_REQUESTED: 'Коды запрошены',
      CODES_RECEIVED: 'Коды получены',
      APPLIED: 'Маркировка нанесена',
      REPORT_PUBLISHED: 'Отчёт получен',
      DONE: 'Завершено',
      FAILED: 'Ошибка',
      PARTIAL_DONE: 'Частично готово',
    },
    summary: {
      NOT_REQUIRED: 'Не требуется',
      DATA_GAP: 'Нужны данные',
      MCHD_NOT_ACTIVE: 'Нужна МЧД',
      WAIT_ON_TS: 'Ожидаем ТС',
      TOPUP_WAIT: 'Нужно пополнение',
      REQUIRED: 'Требуется',
      IN_PROGRESS: 'В процессе',
      DONE: 'Готово',
      PARTIAL_DONE: 'Частично готово',
      FAILED: 'Ошибка',
    },
    applicability: {
      REQUIRED: 'Требуется',
      NOT_REQUIRED: 'Не требуется',
      UNKNOWN: 'Не определено',
    },
    descriptions: {
      NOT_REQUIRED: 'Маркировка не требуется для товаров этой поставки.',
      DATA_GAP: 'Нужны данные по товарам: заполните ТН ВЭД и недостающие атрибуты.',
      MCHD_NOT_ACTIVE: 'Для маркировки требуется активная МЧД.',
      WAIT_ON_TS: 'Маркировка начнётся после прибытия груза на ТС.',
      TOPUP_WAIT: 'Недостаточно средств для услуги маркировки.',
      REQUIRED: 'Требуется маркировка для товаров поставки.',
      IN_PROGRESS: 'Маркировка в процессе выполнения.',
      DONE: 'Маркировка успешно завершена.',
      PARTIAL_DONE: 'Маркировка частично завершена.',
      FAILED: 'При маркировке возникла ошибка.',
    },
    cta: {
      fillData: 'Заполнить данные',
      goToProfile: 'Перейти в профиль',
      viewLogistics: 'Посмотреть логистику',
      goToFinance: 'Перейти в финансы',
      openDocs: 'Открыть в документах',
    },
    taskChecklist: 'Задача маркировки',
    reportReady: 'Отчёт по маркировке: Готов',
    skuList: 'Применимость по товарам',
  },
} as const;

export type RuLabels = typeof ruLabels;